import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/grc')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/grc', ...ROUTE_META['/platform/grc'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'GRC', path: '/platform/grc' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/grc', ...ROUTE_META['/platform/grc'] })),
    ],
  }),
});
